/*
* Created on Mar 03, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import { useState, useEffect } from 'react';
import TextInputComponent from "../../common/Form/TextInputComponent";
import SelectInputComponent from "../../common/Form/SelectInputComponent";
import {DEFAULT_SIZE_LIST, ORGANIZATION_NAME_FORMAT} from "../../../service/common";
import {useTranslation} from "react-i18next";
import CountrySelectComponent from "../../common/Form/CountrySelectComponent";
import TextAreaComponent from "../../common/Form/TextAreaComponent";

const OrganizationFormComponent = ({input, setInput, disPatcher}) => {
    // const DEFAULT_SIZE_LIST = ['1', '2~4', '5~9', '10~24', '25~49', '50~249', '250~999', '1000+']
    const {t} = useTranslation();
    const current_date = new Date().toLocaleDateString('en-US', {month: '2-digit', day: '2-digit', year: 'numeric'});
    const user = JSON.parse(localStorage.getItem('currentUser'));
    const default_description = t('@Enter a description@');
    const init_input = {
        name: {value: '', error: null, required: true},
        description: {value: '', error: null, required: false},
        country: {value:'', error: null, required: true},
        size: {value:'', error: null, required: false},
        website: {value: '', error: null, required: false},
        phone: {value: '', error: null, required: false},
    }
    // const [input, setInput] = useState(init_input);

    useEffect(()=>{
        if (!input.name) {
            setInput(init_input);
        }
    }, []);

    const onChanged = () => {
        disPatcher({type: 'getUpdate', payload: {orgInput: true}})
    }

    return (
        <>
            {input.name &&
            <form onChange={onChanged}>
                <TextInputComponent label={t('@Organization name@')} field_name={'name'} input={input} setInput={setInput} place_holder={t('@Please input your organization name@')} format={ORGANIZATION_NAME_FORMAT} foramtError={t('@Invalid format@')}/>
                {/*<SelectInputComponent label={t('@Country@')} field_name={'country'} input={input} setInput={setInput} listData={DEFAULT_COUNTRY_LIST} useLocale={true} empty_text={t('@Please select your organization country@')} onChange={onChanged} useSearch={true}/>*/}
                <CountrySelectComponent field_name={'country'} input={input} setInput={setInput} useLocale={true} empty_text={t('@Please select your organization country@')} onChange={onChanged} useSearch={true} detectCountry={true}/>
                <SelectInputComponent label={t('@Organization size@')} field_name={'size'} input={input} setInput={setInput} listData={DEFAULT_SIZE_LIST} useLocale={false} empty_text={t('@Please select a approximate number of members in your organization@')} onChange={onChanged}/>
                <TextInputComponent label={t('@Organization website@')} field_name={'website'} input={input} setInput={setInput} place_holder={t('@Please provide official website of your organization@')} />
                <TextInputComponent label={t('@Organization phone number@')} field_name={'phone'} input={input} setInput={setInput} place_holder={t('@Please provide contact number of your organization@')} />
                <TextAreaComponent label={t('@Organization Description@')} field_name={'description'} input={input} setInput={setInput} place_holder={default_description} format={/^.{0,200}$/} foramtError={t('@Invalid format@')}/>
            </form>}
        </>
    );
};

export default OrganizationFormComponent;